import './aquarium-teaser.scss';

require('../../assets/images/light_wood.jpeg');
require('../../assets/images/dark_wood.jpeg');

class AquariumTeaser {
    constructor ($element) {
        this.$aquariumTeaser = $element;
        this.$aquariumTeaserList = this.$aquariumTeaser.querySelector('[data-aquarium-teaser="list"]');
        this.$$aquariumTeaserItems = this.$aquariumTeaser.querySelectorAll('[data-aquarium-teaser="item"]');
        this.dataInview = document.querySelectorAll('[data-inview]:not(.inview)');

        setTimeout(() => {
            this.dataInview.forEach((dataInView) => {
                window.inViewObserver.observe(dataInView);
            });
        }, 500);
    }

    initialize () {
        console.log(this.$aquariumTeaserList, this.$$aquariumTeaserItems);
    }
}

export { AquariumTeaser };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $aquariumTeasers = $context.querySelectorAll('[data-aquarium-teaser="root"]');

        if ($aquariumTeasers.length > 0) {
            for (let i = 0; i < $aquariumTeasers.length; i++) {
                const $aquariumTeaser = new AquariumTeaser($aquariumTeasers[i]);
                $aquariumTeaser.initialize();
            }
        }
    }
});
